require("pixi-particles");
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";

export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [650, 950];


    private _initMaxParticles: number = 150;
    private readonly _coinsConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.6,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 0,
                "end": 0,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 200
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 90,
                "max": 90
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 4,
                "max": 5
            },
            "blendMode": "normal",
            "frequency": 0.03,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -300,
                "y": 0,
                "w": TombOfAkhenatenGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.6,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 0,
                "end": 0,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 200
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 90,
                "max": 90
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 4,
                "max": 5
            },
            "blendMode": "normal",
            "frequency": 0.03,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -300,
                "y": 0,
                "w": TombOfAkhenatenGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.6,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 0,
                "end": 0,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 200
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 90,
                "max": 90
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 4,
                "max": 5
            },
            "blendMode": "normal",
            "frequency": 0.03,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -300,
                "y": 0,
                "w": TombOfAkhenatenGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.6,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 0,
                "end": 0,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 200
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 90,
                "max": 90
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 4,
                "max": 5
            },
            "blendMode": "normal",
            "frequency": 0.03,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -300,
                "y": 0,
                "w": TombOfAkhenatenGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }
    ];

    private _coinsEmiters: Emitter[];
    private _layer: ScalableLayer;
    private _coinsContainer: PIXI.Container;

    private _isPlaying: boolean = false;

    public startFountain(playLevel: number): void {
        // this._isPlaying = true;
        // if (this._isResizeDirty) {
        //     this.onResize(this._resizeData);
        // }
        this._coinsEmiters.forEach((emitter: Emitter, index: number) => {
            if (playLevel === 0 && index === 0) {
                emitter.emit = true;
            } else if (playLevel === 1 && (index <= playLevel)) {
                emitter.emit = true;
            } else if (playLevel === 2 && index === 1) {
                emitter.emit = true;
            } else emitter.emit = playLevel === 3 && (index === 1 || index === 2);
        });
    }

    public stopFountain(): void {
        this._coinsEmiters.forEach((emitter: Emitter) => {
            emitter.emit = false;
            emitter.maxParticles = this._initMaxParticles;
        });
    }

    protected initAnimations(): void {
        this._layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.BIG_WIN.name);
        this._coinsContainer = new PIXI.Container();
        this._layer.addChildAt(this._coinsContainer, 0);
        this._coinsEmiters = [];
        this._coinsConfigs.forEach((config: any, level: number) => {
            const emitter: Emitter = new Emitter(this._coinsContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmiters.push(emitter);
        });
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.PORTRAIT) {
            this._coinsContainer.position.set(300, -360);
        } else {
            this._coinsContainer.position.set(0, 0);
        }

        let screenHeight: number = Math.round(resizeData.height / this._layer.scale.y);
        screenHeight = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y: number = Math.round((resizeData.height - this._layer.y) / this._layer.scale.y) + 20;
        this._coinsEmiters.forEach((emitter: Emitter, level: number) => {
            const levelSpeed: number = startSpeed * (1 + 0.05 * level);
            emitter.startSpeed.value = levelSpeed;
            emitter.spawnPos.y = -20;
            emitter.spawnRect.width = this._resizeData.width; // #286
        });
    }


}